export default {
  state: {
    locale: {
      metadata: {},
      phrases: {
      }
    }
  },
  mutations: {
    setLocale(state, value) {
      state.locale = value
    }
  },
  actions: {
    async loadLocale({ dispatch, commit }) {
      await commit('setLocale', await dispatch('apiQuery', {method: '/locale'}))
    },
    async setLocale({ dispatch, commit }, locale) {
      await commit('setLocale', await dispatch('apiQuery', {method: '/locale', body: { locale }}))
    },
    async getAvailableLocales({ dispatch }) {
      return await dispatch('apiQuery', {method: '/locale_list'})
    }
  },
  getters: {
    locale_phrases(state) {
      return state.locale.phrases
    },
    locale_metadata(state) {
      return state.locale.metadata
    },
    localePhrase(_, getters) {
      return (phrase) => {
        let phrases = getters.locale_phrases
        let trans_phrase = phrases[phrase.replaceAll('\n', '\\n')] //fix for phrases with line feed

        return trans_phrase !== undefined ? trans_phrase || phrase : process.env.NODE_ENV == 'development' ? `->{ ${phrase} }<-` : phrase
        
        // if (phrase in phrases) {
        //   return phrases[phrase] ? phrases[phrase] : phrase
        // } else {
        //   return process.env.NODE_ENV == 'development' ? `->{ ${phrase} }<-` : phrase
        // }
      }
    }
  }
}